"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var InputField_1 = require("./inputField/InputField");
var DatePicker_1 = require("../../../common/components/dateField/DatePicker");
var TextareaAutosizeInput_1 = require("./textareaAutosizeInput/TextareaAutosizeInput");
var PriceInput_1 = require("./priceInput/PriceInput");
var CustomComponentsMapper = function () {
    return {
        PriceInput: function (inputData) { return <PriceInput_1.default formData={inputData}/>; },
        TextWidget: function (inputData) { return <InputField_1.default formData={inputData}/>; },
        DateWidget: function (dateData) { return <DatePicker_1.default formData={dateData}/>; },
        TextareaAutosizeWidget: function (inputData) { return <TextareaAutosizeInput_1.default formData={inputData}/>; },
    };
};
exports.default = CustomComponentsMapper;
